import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type TokenStore = {
  token: string;
  setToken: (token: string) => void;
};

const useTokenStore = create(
  persist<TokenStore>(
    (set) => ({
      token: "",
      setToken: (token: string) => set({ token }),
    }),
    {
      name: "token-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

const useToken = () => {
  const { token, setToken } = useTokenStore();
  const tokenFresh = useTokenStore.getState().token;
  return { token, setToken, tokenFresh };
};

export default useToken;
